import React from 'react';
import { AlertCircle } from 'lucide-react';

const UnsavedChangesNotice = ({ 
  message = "You have unsaved changes",
  description = "Your changes will be lost if you don't save them. Click \"Save Changes\" to save your updates."
}) => {
  return (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
      <div className="flex items-start">
        <AlertCircle className="h-5 w-5 text-yellow-400 mr-3 mt-0.5 flex-shrink-0" />
        <div>
          <h4 className="text-sm font-medium text-yellow-800">{message}</h4>
          <p className="text-sm text-yellow-700 mt-1">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesNotice;

